import { useCallback, useEffect } from 'react';

import { usePurchaseCompleteHandler } from 'src/stores/payments/usePurchaseCompleteHandler';
import { PurchaseCompleteMessage, WindowMessage, WindowMessageType } from 'src/types/message';

/**
 * 자체적으로 구현한 어플케이션 내 message event 처리
 */
const useCustomWindowMessageEvent = () => {
  const handlePurchaseComplete = usePurchaseCompleteHandler();

  const handlePurchaseCompleteMessage = useCallback(
    (message: PurchaseCompleteMessage) => {
      handlePurchaseComplete(message.productModuleType);
    },
    [handlePurchaseComplete]
  );

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const message = event.data;
      if (!message?.type) return;

      const customWindowMessage = message as WindowMessage;

      switch (customWindowMessage.type) {
        case WindowMessageType.PurchaseComplete:
          handlePurchaseCompleteMessage(customWindowMessage);
          break;
        default:
          break;
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handlePurchaseCompleteMessage]);
};

export default useCustomWindowMessageEvent;
